import { usePodcastProvider, PodcastConfig, ModalType } from "components/podcast/PodcastProvider";
import { useUrlQueryParams } from "hooks";
import { useHistory, useLocation } from "react-router";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";

//ui
import { Flex, Modal, ModalOverlay, ModalContent, ModalBody, IconButton, useMediaQuery, Show } from "@chakra-ui/react";
import { CloseIcon, ChevronFillIcon } from "components/icons";
import { EpisodeDetailsButton, SubscribeButton, ShareButton, DownloadButton } from "./ModalButtons";
import { EpisodeDetailsModalContent, SubscribeModalContent, ShareModalContent, DownloadModalContent } from "./ModalContents";
import PodcastColorTypes from "types/podcastColorTypes";

interface ModalInterface {
  modalButtonType: ModalType;
  podcastDetails?: PodcastConfig;
}
export function PodcastModal({ modalButtonType, podcastDetails }: ModalInterface) {
  const history = useHistory();
  const location = useLocation();

  const { isOpen, onOpen, onClose, modalType, setPlayingPodcast, playingPodcast, setPlayPodcast, setModalType } = usePodcastProvider();
  const [isLargerThan766] = useMediaQuery("(min-width: 766px)");

  const query = useUrlQueryParams();

  const modalButtons = {
    [ModalType.Details]: <EpisodeDetailsButton onOpen={onOpen} podcastDetails={podcastDetails} />,
    [ModalType.Subscribe]: <SubscribeButton onOpen={onOpen} />,
    [ModalType.Share]: <ShareButton onOpen={onOpen} podcastDetails={podcastDetails} />,
    [ModalType.Download]: <DownloadButton onOpen={onOpen} podcastDetails={podcastDetails} />
  };

  const modalContents = {
    [ModalType.Details]: EpisodeDetailsModalContent,
    [ModalType.Subscribe]: SubscribeModalContent,
    [ModalType.Share]: ShareModalContent,
    [ModalType.Download]: DownloadModalContent
  };

  const handleClose = () => {
    const currentEpisodeNumber = Number(query.get("episode_number"));
    if (currentEpisodeNumber) {
      history.replace({ pathname: location.pathname });
    }
    onClose();
    if (playingPodcast?.video_urls) {
      setPlayingPodcast(null);
      setPlayPodcast(false);
      setModalType(null);
    }
  };
  const enableScroll = isLargerThan766;
  const displayChevron = modalType === ModalType.Details ? "block" : "none";

  const ModalContentsComponent = modalType && modalContents[modalType];

  const showModal = modalType === modalButtonType && isOpen;

  const modalButton = modalButtons[modalButtonType];

  const modalWidth = modalType === ModalType.Details ? "1320px" : "872px";

  return (
    <Flex fontFamily="sora">
      {modalButton}
      <Show breakpoint="(min-width: 766px)">
        <Modal isOpen={showModal} onClose={onClose} blockScrollOnMount={enableScroll} trapFocus={false} scrollBehavior="outside" isCentered>
          <ModalOverlay />
          <ModalContent backgroundColor={getPodcastThemeToken(PodcastColorTypes.EpisodeModalBackground)} px="16px" py="14px" maxWidth={modalWidth} width="100%" display={{ base: "none", md: "flex" }}>
            <Flex width="100%" height="48px" position="relative">
              <IconButton
                icon={<ChevronFillIcon width="48px" height="48px" />}
                width="24px"
                aria-label="close-modal"
                bg="transparent"
                borderRadius="24px"
                _hover={{ bg: "transparent" }}
                color="purple.50"
                onClick={handleClose}
                display={displayChevron}
                ml="8px"
              />
              <IconButton
                icon={<CloseIcon width="48px" height="48px" />}
                width="24px"
                aria-label="close-modal"
                bg="transparent"
                borderRadius="24px"
                _hover={{ bg: "transparent" }}
                color="purple.50"
                position="absolute"
                right="0"
                onClick={handleClose}
              />
            </Flex>
            <ModalBody px="0" display={showModal ? "block" : "none"}>
              {modalType && ModalContentsComponent && <ModalContentsComponent />}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Show>
    </Flex>
  );
}
